export const HEADERS = [
	'Name',
	'Consultant',
	'Point from',
	'Point to',
	'Min length',
	'Max length',
	'Actions',
];
